import { Box } from "@material-ui/core"
import dynamic from "next/dynamic"
import styled from "styled-components"
import loader from "../../public/animation/loader.json"

const Lottie = dynamic(() => import("lottie-react"), { ssr: false })

const StyledWrapper = styled(Box)`
  height: 100vh;
`
const StyledLottie = styled(Lottie)`
  height: 80%;
  margin-top: 50px;
  ${(p) => p.theme.breakpoints.up("md")} {
    svg {
      width: 40% !important;
    }
  }
`
type Props = {
  className?: string
}

const Loader = ({ className }: Props) => {
  return (
    <StyledWrapper className={className}>
      <StyledLottie animationData={loader} />
    </StyledWrapper>
  )
}

export default Loader
